import { useContext, useEffect, useState } from 'react';
import './index.less'
import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import { CommonTabbarContext, SystemContext } from '@/App';
import { useParams } from 'react-router-dom';
import { SystemStatus } from '@/global/store/system-store';
import { getMonitorParameterById, updateExtParameter, updateMonitorParameter } from '@/api/monitor-object/monitor-parameter';
import { MonitorParameter, MonitorParameterExt } from '@/global/interface/monitor-object/monitor-parameter';
import { TAB_TYPE } from '@/enums/tab-type';
import TnMessage from '@/global/components/message';
import { Modal, Radio, Select, Skeleton, Switch, message } from 'antd';
import { getFunctionByUuid, getFunctionsByParameterId } from '@/api/lib/lib-monitor-parameter';
import { GlobalMonitorParameterFunc } from '@/global/interface/lib-device/global-monitor-parameter';
import { ReactComponent as AddSvg } from './icons/add.svg'
import { ReactComponent as TextSvg } from './icons/edit.svg'
import { MONITOR_PARAMETER_TYPE } from '@/enums/monitor-parameter-type';
import TnInput from '@/global/components/input/tn-input';
import { emitter } from '@/global/listeners';
import { Emit_Event } from '@/enums/emit-event';
import { SENSOR_TYPE_LIST } from '@/enums/sensor-type';
import { getGlobalSensors } from '@/api/lib/lib-sensor';
import { GlobalSensor } from '@/global/interface/lib-device/global-sensor';
import { Transfer2BackEndScale, Transfer2DisplayScale } from '@/global/utils/unit-type';
import { InlineMath } from 'react-katex';
import ParamsDataPanel from '@/global/components/params-data-panel';
import MonixModal from '@/global/components/monix-modal';
import { CalibrationPanel } from './calibration';
import { SensorParameter } from '@/global/interface/device/sensor';
import { GlobalMonitorParameterFuncType } from '@/enums/global-monitor-parameter-func-type';
import { ExtParamPanel } from './ext-param';
import { clearExtParameter, generateCalibrationResult } from '@/api/monitor-object/calibration';
import classNames from 'classnames';

/**
 * 监测参数详情页
 */
export default function MonitorParameterDetail() {
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const { monitorParameterId } = useParams()
    const systemContext = useContext<SystemStatus>(SystemContext); // system上下文
    const [loading, setLoading] = useState<boolean>(false); // 加载状态
    const [item, setItem] = useState<MonitorParameter>(); // 监测参数
    const [funcs, setFuncs] = useState<GlobalMonitorParameterFunc[]>([]); // 该监测参数的计算方法
    const [globalSensors, setGlobalSensors] = useState<GlobalSensor[]>([]); // 全局库中可选的传感器

    const [currentFunc, setCurrentFunc] = useState<GlobalMonitorParameterFunc>(null);

    // 数据面板显示
    const [showDataPanel, setShowDataPanel] = useState<boolean>(false)
    const [showDataParam, setShowDataParam] = useState<MonitorParameter>(null)
    const [showCalibration, setShowCalibration] = useState<boolean>(false);
    // 额外参数设置弹窗
    const [extModal, setExtModal] = useState<boolean>(false);
    // 摄像头选择通道变量
    const [sensorMap, setSensorMap] = useState<{ [key: number]: SensorParameter[] }>({})

    useEffect(() => {
        const funcUuid = item?.globalMonitorParameterFuncUuid;
        const index = funcs?.findIndex(func => func.uuid === funcUuid);
        if (index >= 0) {
            const func = funcs[index];
            setCurrentFunc(func);
        }
    }, [item, funcs])

    useEffect(() => {
        if (!monitorParameterId) return;
        // 获得监测参数详情
        setLoading(true);
        getMonitorParameterById(+monitorParameterId).then(res => {
            let data: MonitorParameter = res.data;
            setSensorMap(data.sensorMap || {})
            // 转成显示单位，需乘的系数
            let scale = Transfer2DisplayScale(data.unit);
            setItem({
                ...data,
                value0Dis: data.value0 != null ? scale * data.value0 : null,
                t2Dis: data.t2 != null ? scale * data.t2 : null,
                t3Dis: data.t3 != null ? scale * data.t3 : null,
                t4Dis: data.t4 != null ? scale * data.t4 : null,
            });
            // 新增页签
            let addTab: TabRoute = {
                title: `${data.encoding}${data.name}${data.code}` || '',
                url: `${TAB_TYPE.MONITOR_PARAMETER}/${monitorParameterId}`,
                closable: true
            }
            commonTabbarContext.pushRoute(addTab)
            // 获得该监测参数的计算方法
            getFunctionsByParameterId(data.globalMonitorParameterId).then(res => {
                let funcs: GlobalMonitorParameterFunc[] = res.data || [];
                setFuncs(funcs);
            })
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得监测参数详情失败")
            }
        }).finally(() => {
            setLoading(false);
        })

    }, [monitorParameterId, systemContext.needRenderTab])

    useEffect(() => {
        // 获得全局传感器
        getGlobalSensors().then(res => {
            // 获得全局传感器
            let list: GlobalSensor[] = res.data || [];
            setGlobalSensors(list);
        }).catch(() => {
            TnMessage.error("获得传感器型号失败");
        })
    }, [])

    // 点击了新增方法
    const onClickAddFunc = () => {
        // todo
        TnMessage.info("暂未开发");
    }

    // 打开监测对象详情
    const onOpenMonitorObjectDetail = (monitorObjectId: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_OBJECT}/${monitorObjectId}`)
    }

    // 选择了计算方法
    const onSelectFunc = (funcUuid: string) => {
        const index = funcs.findIndex(item => item.uuid === funcUuid);
        if (index >= 0) {
            const func = funcs[index];
            setCurrentFunc(func);
        }


        // 根据计算方法uuid查询计算方法详情
        getFunctionByUuid(funcUuid).then(res => {
            let data: GlobalMonitorParameterFunc = res.data;
            // 输入参数
            let paramInList = data.paramInList || [];
            // 输入参数中的间接参数
            let subGlobalParameters = paramInList.filter(item => item.type == MONITOR_PARAMETER_TYPE.INDIRECT);
            // 输入参数中的直接参数
            let subGlobalParametersDq = paramInList.filter(item => item.type == MONITOR_PARAMETER_TYPE.DIRECT);
            // 转成监测参数的格式
            let subParameters = subGlobalParameters.map(globalParameter => {
                return {
                    type: globalParameter.type,
                    superMonitorParameterId: +monitorParameterId,
                    globalMonitorParameterId: globalParameter.id,
                    name: globalParameter.name,
                    code: globalParameter.symbol,
                }
            })
            let subParametersDq = subGlobalParametersDq.map(globalParameter => {
                return {
                    type: globalParameter.type,
                    superMonitorParameterId: +monitorParameterId,
                    globalMonitorParameterId: globalParameter.id,
                    name: globalParameter.name,
                    code: globalParameter.symbol,
                    location: globalParameter.location,
                }
            })
            setItem({
                ...item,
                globalMonitorParameterFuncUuid: funcUuid,
                subParameters: subParameters,
                subParametersDq: subParametersDq
            })
        }).catch(() => {
            TnMessage.error("获得计算方法有误");
        })
    }

    // 保存监测参数详情
    const onSaveDetail = () => {
        // 转成国际单位下的数值
        let scale = Transfer2BackEndScale(item.unit);
        let data = {
            ...item,
            value0: item.value0Dis != null ? scale * item.value0Dis : null,
            t2: item.t2Dis != null ? scale * item.t2Dis : null,
            t3: item.t3Dis != null ? scale * item.t3Dis : null,
            t4: item.t4Dis != null ? scale * item.t4Dis : null,
        }
        updateMonitorParameter(+monitorParameterId, data).then(res => {
            TnMessage.success("更新成功");
            emitter.emit(Emit_Event.UPDATE_MONITOR_PARAMETER, item);
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    // 为直接参数选择了设备类型
    const onSelectDeviceType = (idx, deviceType) => {
        // 该设备类型的传感器
        let sensors = globalSensors.filter(item => item.type == deviceType);
        // 默认选中第一个
        let globalSensorId = null;
        if (sensors.length > 0) {
            globalSensorId = sensors[0].id;
        }
        let subParamDq = item.subParametersDq[idx];
        subParamDq.sensorType = deviceType;
        subParamDq.globalSensorId = globalSensorId != null ? globalSensorId : null;
        setItem({
            ...item,
        })
    }

    // 为直接参数设置了代号
    const onChangeCode = (idx, code) => {
        let subParamDq = item.subParametersDq[idx];
        subParamDq.code = code;
        setItem({
            ...item,
        })
    }
    // 为直接参数选择了设备型号
    const onSelectGlobalSensor = (idx, globalSensorId) => {
        let subParamDq = item.subParametersDq[idx];
        subParamDq.globalSensorId = globalSensorId;
        setItem({
            ...item,
        })
    }

    // 打开传感器详情
    const openSensorDetail = (sensorId: number, sensorType: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${sensorId}/sensor`)
    }

    if (item == null) {
        return (
            <div></div>
        )
    }

    // 展示数据
    const onClickShowData = (param) => {
        setShowDataParam(param)
        setShowDataPanel(true)
    }

    const onClickDeviceDetail = (param) => {
        commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${param.sensorId}/sensor`)
    }

    /**
     * 清空外参
     */
    const onClickClearExtParameter = () => {
        // .then(res => {
        //     console.log('res', res)
        // })

        Modal.confirm({
            title: '清空',
            content: '确认清空该监测参数的外参吗？',
            wrapClassName: classNames({
                'delete-modal-panel tn-modal-panel': true,
            }),
            icon: null,
            onCancel: () => {
                Modal.destroyAll();
            },
            onOk: () => {
                clearExtParameter(+monitorParameterId).catch(e => {
                    message.error("清空失败")
                }).finally(() => {
                    Modal.destroyAll();
                })
            }
        });
    }

    return (
        <div className='monitor-parameter-main'>
            <div className="monitor-parameter-detail">
                <Skeleton loading={loading}>
                    <div className="item">
                        <div className="label">参数编号</div>
                        <div className="text-value">{item.encoding}</div>
                    </div>
                    <div className="item">
                        <div className="label">参数名称</div>
                        <div className="text-value">{item.name}</div>
                    </div>
                    <div className="item">
                        <div className="label">参数代号</div>
                        <TnInput value={item.code} style={{ width: '240px' }} onTextChange={(value) => setItem({ ...item, code: value })} />
                    </div>
                    <div className="item">
                        <div className="label">参数初值</div>
                        <TnInput value={item.value0Dis}
                            style={{ width: '240px' }}
                            onTextChange={(value) => {
                                const reg = /^-?\d*(\.\d*)?$/;
                                if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                    setItem({ ...item, value0Dis: value })
                                }
                            }}
                            suffix={<InlineMath math={item.unit} />}
                        />
                    </div>
                    <div className="item">
                        <div className="label">二级预警阈值</div>
                        <TnInput value={item.t2Dis}
                            style={{ width: '240px' }}
                            onTextChange={(value) => {
                                const reg = /^-?\d*(\.\d*)?$/;
                                if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                    setItem({ ...item, t2Dis: value })
                                }
                            }}
                            suffix={<InlineMath math={item.unit} />}
                        />
                    </div>
                    <div className="item">
                        <div className="label">三级预警阈值</div>
                        <TnInput value={item.t3Dis}
                            style={{ width: '240px' }}
                            onTextChange={(value) => {
                                const reg = /^-?\d*(\.\d*)?$/;
                                if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                    setItem({ ...item, t3Dis: value })
                                }
                            }}
                            suffix={<InlineMath math={item.unit} />}
                        />
                    </div>
                    <div className="item">
                        <div className="label">四级预警阈值</div>
                        <TnInput value={item.t4Dis}
                            style={{ width: '240px' }}
                            onTextChange={(value) => {
                                const reg = /^-?\d*(\.\d*)?$/;
                                if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                    setItem({ ...item, t4Dis: value })
                                }
                            }}
                            suffix={<InlineMath math={item.unit} />}
                        />
                    </div>
                    <div className="item">
                        <div className="label">所属监测对象</div>
                        <div className="text-value link" onClick={() => onOpenMonitorObjectDetail(item.monitorObjectId)}>{item.monitorObjectName}</div>
                    </div>
                    {item?.code == "deform" && (
                        <div className='item'>
                            <div className="label">开启位移识别</div>
                            <Switch
                                size='small'
                                value={item?.parameterExt?.openDetection || false}
                                onChange={(e) => {
                                    updateExtParameter(+monitorParameterId, { openDetection: e }).then(res => {
                                        if (!item.parameterExt) {
                                            item.parameterExt = {}
                                        }
                                        item.parameterExt.openDetection = e
                                        setItem({ ...item })
                                    }).catch(e => {
                                        message.error("更新失败")
                                    })
                                }} />
                        </div>
                    )}
                    {item?.code == "invasion_size" && (
                        <div className='item'>
                            <div className="label">开启异物识别</div>
                            <Switch
                                size='small'
                                value={item?.parameterExt?.openDetection || false}
                                onChange={(e) => {
                                    updateExtParameter(+monitorParameterId, { openDetection: e }).then(res => {
                                        if (!item.parameterExt) {
                                            item.parameterExt = {}
                                        }
                                        item.parameterExt.openDetection = e
                                        setItem({ ...item })
                                    }).catch(e => {
                                        message.error("更新失败")
                                    })
                                }} />
                        </div>
                    )}
                    <div className="item">
                        <div className="label">计算方法</div>
                        <Select className="func-select" value={item.globalMonitorParameterFuncUuid} onChange={value => onSelectFunc(value)}>
                            {funcs.map(func => (
                                <Select.Option value={func.uuid}>{func.name}</Select.Option>
                            ))}
                        </Select>
                        <div className="add-func-btn" onClick={onClickAddFunc}><AddSvg />新增方法</div>
                        {(currentFunc && currentFunc.type == GlobalMonitorParameterFuncType.TILT_BOTH_EYES) && (
                            <div className="add-func-btn" onClick={onClickClearExtParameter}><TextSvg />清空外参</div>
                        )}
                    </div>
                    {item.subParameters.length > 0 && (
                        <div className="item">
                            <div className="label">间接参数</div>
                            {item.subParameters.map(param => (
                                <div className="text-value">{`${param.encoding || ''}${param.name || ''}${param.code || ''}`}</div>
                            ))}
                        </div>
                    )}
                    <div className="item param-dq-row">
                        <div className="label">直接参数编号</div>
                        <div className="label short">直接参数名称</div>
                        <div className="label short">直接参数代号</div>
                        <div className="label length">设备类别</div>
                        <div className="label length">设备型号</div>
                        <div className="label length">设备编号</div>
                        <div className="label">操作</div>
                        <div className="label">操作</div>
                    </div>
                    {item.subParametersDq.map((param, idx) => (
                        <div className="item param-dq-row">
                            <div className="text-value">{item.encoding}-{param.location || ''}</div>
                            <div className="text-value short">{param.name}</div>
                            <div style={{ width: '100px' }}><TnInput value={param.code} style={{ width: '100px' }} onTextChange={(value) => onChangeCode(idx, value)} /></div>
                            <Select className="select-device-type" value={param.sensorType} onChange={value => onSelectDeviceType(idx, value)}>
                                {SENSOR_TYPE_LIST.map(item => (
                                    <Select.Option value={item.value}>{item.label}</Select.Option>
                                ))}
                            </Select>
                            <Select className="select-device-type" value={param.globalSensorId} onChange={value => onSelectGlobalSensor(idx, value)}>
                                {globalSensors.filter(gs => gs.type == param.sensorType).map(item => (
                                    <Select.Option value={item.id}>{item.marking}</Select.Option>
                                ))}
                            </Select>
                            <div className="btn-block length">
                                {param.sensorId &&
                                    <div className="link-btn" title={param.sensorCode} onClick={() => openSensorDetail(param.sensorId, param.sensorType)}><div className="text ellipsis">{param.sensorCode}</div></div>
                                }
                                {!param.sensorId && <div className="text-value">/</div>}
                            </div>
                            <div className="btn-block" onClick={() => { onClickShowData(param) }}><div className="open-detail-btn"><span>数据显示</span></div></div>
                            <div className="btn-block" onClick={() => { onClickDeviceDetail(param) }}><div className="open-detail-btn"><span>采集设备详情</span></div></div>
                            {(param.code == "video" || param.code == "invasion_image1") && param.sensorId && (
                                <Select
                                    className="select-device-type"
                                    value={param.sensorParameterId}
                                    onChange={value => {
                                        updateMonitorParameter(param.id, { sensorParameterId: value }).then(res => {
                                            let subParamDq = item.subParametersDq[idx];
                                            subParamDq.sensorParameterId = value;
                                            setItem({
                                                ...item,
                                            })
                                        })
                                    }}
                                    options={(sensorMap[param.sensorId] || [])?.filter(p => p.globalMonitorParameterId == 4).map((p => {
                                        return {
                                            label: p.idx,
                                            value: p.id
                                        }
                                    }))}
                                />
                            )}

                        </div>
                    ))}
                    <div style={{ flex: '1 1 auto' }}></div>
                    <div style={{ "display": "flex" }}>
                        <div className="primary-btn" onClick={onSaveDetail}>
                            <div className="text">
                                保存
                            </div>
                        </div>
                        {
                            (currentFunc && item?.code == "deform") && (
                                // (currentFunc && [GlobalMonitorParameterFuncType.PARALLEL_BINOCULAR, GlobalMonitorParameterFuncType.TILT_BOTH_EYES].includes(currentFunc?.type)) && (
                                <>
                                    <div className="primary-btn" onClick={() => { setExtModal(true) }}>
                                        <div className="text">
                                            额外参数
                                        </div>
                                    </div>
                                    <div className="primary-btn" onClick={() => { setShowCalibration(true) }}>
                                        <div className="text">
                                            标定
                                        </div>
                                    </div>
                                </>
                            )
                        }

                    </div>

                </Skeleton>
            </div>
            {showDataPanel && <ParamsDataPanel onClickClose={setShowDataPanel} sensorId={showDataParam?.sensorId} symbol={showDataParam?.symbol} type={"sensor"} unit={showDataParam?.unit} name={showDataParam?.name} />}

            <MonixModal
                hideFooter
                wrapClassName='calibration-modal-container'
                title='摄像头标定'
                visible={showCalibration}
                setVisible={setShowCalibration}
                children={(
                    <CalibrationPanel
                    />
                )}
            />

            <MonixModal
                title={'额外参数设置'}
                visible={extModal}
                setVisible={setExtModal}
                wrapClassName='ext-param-model-main'
                hideFooter
            >
                <ExtParamPanel
                    paramId={item?.id}
                    data={item?.parameterExt}
                    onClickCancel={() => { setExtModal(false) }}
                    onClickConfirm={(param: MonitorParameterExt) => {
                        item.parameterExt = param
                        setItem({ ...item })
                        setExtModal(false)
                    }}
                />
            </MonixModal>

        </div>

    )
}